import { NEXT_STEP } from "ducks/onboarding";
import {
	getCenterCrop,
} from "apps/photo_upload/util/helpers";
import {
	uploadPhotoFile,
	uploadPhotoDetails,
} from "shared/util/PhotoUpload";

import {
	loadFileLocally,
} from "apps/photo_upload/util/web";


// initial state
// ----------------------------------------------------------------------------

export const INITIAL_STATE = {
	isUploadingPhoto: false,
};


// action types
// ----------------------------------------------------------------------------

export const UPLOAD_FILE = "PHOTO_UPLOAD.UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "PHOTO_UPLOAD.UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_CANCEL = "PHOTO_UPLOAD.UPLOAD_FILE_CANCEL";
export const UPLOAD_FILE_ERROR = "PHOTO_UPLOAD.UPLOAD_FILE_ERROR";

export const UPLOAD_DETAILS = "PHOTO_UPLOAD.UPLOAD_DETAILS";
export const UPLOAD_DETAILS_SUCCESS = "PHOTO_UPLOAD.UPLOAD_DETAILS_SUCCESS";

export const READ_LOCAL_FILE = "PHOTO_UPLOAD.READ_LOCAL_FILE";
export const READ_LOCAL_FILE_SUCCESS = "PHOTO_UPLOAD.READ_LOCAL_FILE_SUCCESS";

export const RESET_UPLOADER = "PHOTO_UPLOAD.RESET_UPLOADER";
export const EXTERNAL_UPLOADER_SUCCESS = "PHOTO_UPLOAD.EXTERNAL_UPLOADER_SUCCESS";
export const SAVE_CROP = "PHOTO_UPLOAD.SAVE_CROP";


// reducer
// ----------------------------------------------------------------------------

export function reducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case RESET_UPLOADER: {
			return {
				...state,
				selectedPhoto: null,
				localPhoto: {},
			};
		}

		// if the next step action is a skip, remove the selected photo
		case NEXT_STEP: {
			if (action.params && action.params.skipped) {
				return {
					...state,
					selectedPhoto: null,
				};
			}

			return state;
		}

		case UPLOAD_FILE: {
			return {
				...state,
				isUploadingPhoto: true,
			};
		}

		case UPLOAD_FILE_SUCCESS: {
			let cropInfo;

			if (action.crop) {
				cropInfo = action.crop;
			} else {
				cropInfo = getCenterCrop(
					action.width,
					action.height,
				);
			}

			const res = {
				id: action.picid || action.id,
				src: action.src,
				thumb: action.thumb,
				caption: action.caption || null,
				square: action.square || null,
				error: null,
				cropInfo,
			};

			if (action.width && action.height) {
				res.width = action.width;
				res.height = action.height;
			}

			return {
				...state,
				selectedPhoto: {
					...state.selectedPhoto,
					...res,
				},
				isUploadingPhoto: false,
			};
		}

		case UPLOAD_FILE_CANCEL: {
			return {
				...state,
				isUploadingPhoto: false,
			};
		}

		case UPLOAD_FILE_ERROR: {
			return {
				...state,
				selectedPhoto: {
					error: action.error,
				},
				isUploadingPhoto: false,
			};
		}

		case SAVE_CROP: {
			return {
				...state,
				selectedPhoto: {
					...state.selectedPhoto,
					src: action.cropInfo.src,
					cropInfo: action.cropInfo,
				},
			};
		}

		case UPLOAD_DETAILS: {
			return state;
		}

		case UPLOAD_DETAILS_SUCCESS: {
			return state;
		}

		case READ_LOCAL_FILE: {
			return {
				...state,
				isUploadingPhoto: true,
			};
		}

		case READ_LOCAL_FILE_SUCCESS: {
			return {
				...state,
				localPhoto: action.photoInfo,
			};
		}

		default: {
			return state;
		}
	}
}


// action creators
// ----------------------------------------------------------------------------

export function resetUploader() {
	return {
		type: RESET_UPLOADER,
	};
}

export function triggerUploader() {
	return { type: UPLOAD_FILE };
}

export function uploadFile(file, userid, albumid, handlers) {
	return (dispatch) => {
		dispatch({ type: UPLOAD_FILE });
		uploadPhotoFile(
			file,
			userid,
			albumid,
			(photoInfo) => {
				dispatch({
					type: UPLOAD_FILE_SUCCESS,
					...photoInfo,
				});

				if (handlers && handlers.onUploadSuccess) {
					handlers.onUploadSuccess(photoInfo);
				}
			},
			(error) => {
				dispatch({
					type: UPLOAD_FILE_ERROR,
					error,
				});

				if (handlers && handlers.onUploadFailure) {
					handlers.onUploadFailure(error);
				}
			},
		);
	};
}

export function readLocalFile(file) {
	return (dispatch) => {
		dispatch({ type: READ_LOCAL_FILE });

		loadFileLocally(
			file,
			(photoInfo) => {
				dispatch({
					type: READ_LOCAL_FILE_SUCCESS,
					photoInfo,
				});
			},
		);
	};
}

export function saveCrop(cropInfo) {
	return {
		type: SAVE_CROP,
		cropInfo,
	};
}

export function uploadFileDetails(params) {
	return (dispatch) => {
		dispatch({ type: UPLOAD_DETAILS });

		uploadPhotoDetails(params)
			.then((res = {}) => {
				dispatch({
					type: UPLOAD_DETAILS_SUCCESS,
					picid: res.picid || res.id,
					src: res.url,
					thumb: res.thumb_url,
				});
			})
			.catch((error) => {
				console.info("UPLOAD_DETAILS_FAILED", error);
			});
	};
}

export function externalUploadSuccess(selectedPhoto) {
	return (dispatch) => {
		// dispatch success...
		dispatch({
			type: UPLOAD_FILE_SUCCESS,
			...selectedPhoto,
		});
	};
}

export function externalUploadFailure(error) {
	return {
		type: UPLOAD_FILE_ERROR,
		error: error || "We couldn’t upload that photo!",
	};
}

export function externalUploadCancel() {
	return {
		type: UPLOAD_FILE_CANCEL,
	};
}



// WEBPACK FOOTER //
// ./src/ducks/photo_upload.js